<template>
	<section class="card card-fast-payment active">
		<h2>zasil rachunek fx</h2>
		<p v-if="windowWidth < mobileBreakpoint">Błyskawicznie i bez dodatkowych opłat</p>

		<fast-payment-form v-if="showMTransfer || showPaynow" />
		<div v-else style="margin-top: 20px">
			Przepraszamy, na ten moment zasilenie rachunku jest niemożliwe.<br />
			Prosimy spróbować później.
		</div>
	</section>
</template>

<script>
import FastPaymentForm from '@/views/dashboard/partial/_FastPaymentForm';
import { mapGetters } from 'vuex';

export default {
	components: {
		FastPaymentForm,
	},
	computed: {
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		...mapGetters({ mobileBreakpoint: 'getMobileBreakpoing', showMTransfer: 'getShowMTransfer', showPaynow: 'getShowPaynow' }),
	},
};
</script>
